import React, { useEffect } from 'react';
import styled from 'styled-components';

import { ReactComponent as BackIcon } from './back-icon.svg';

const Container = styled.div`
  height: 40px;
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 15px;
  background-color: white;
  border-radius: 5px;
  user-select: none;
  border: 1px solid #d9d9d980;
  cursor: pointer;

  img {
    margin-right: 10px;
  }

  p {
    font-size: 1.4rem;
    color: #009fe4;
  }
`;

interface Props {
  text: string;
  onClick: () => void;
}

export default function PageBackControl(props: Props) {
  const { text, onClick } = props;

  return (
    <Container onClick={onClick}>
      <BackIcon />
      <p>{text}</p>
    </Container>
  );
}